"use client";

import React from "react";
const galleryImages = [{
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8792.png",
  alt: "Занятия в центре MONA",
  caption: "Ежедневные занятия",
  className: "md:col-span-2 md:row-span-2"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8568.png",
  alt: "Тренировки и движение",
  caption: "Движение и тренировки",
  className: "md:col-span-1 md:row-span-1"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8570.png",
  alt: "Работа с тренером",
  caption: "Работа с тренером",
  className: "md:col-span-1 md:row-span-1"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8569.png",
  alt: "Активности на природе",
  caption: "Активности на природе",
  className: "md:col-span-1 md:row-span-2"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8792.png",
  alt: "Атмосфера центра",
  caption: "Атмосфера центра",
  className: "md:col-span-2 md:row-span-1"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8570.png",
  alt: "Активные моменты дня",
  caption: "Активные моменты дня",
  className: "md:col-span-1 md:row-span-1"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8568.png",
  alt: "Радость движения",
  caption: "Радость движения",
  className: "md:col-span-1 md:row-span-1"
}];
export default function GalleryTilesSection() {
  return <section className="bg-[#fbfbf8] px-6 py-16 text-slate-950 md:px-12 md:py-20">
      <div className="mx-auto max-w-4xl text-center">
        <div className="mb-5 inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-slate-600 shadow-sm sm:text-xs">
          Жизнь центра
        </div>

        <h2 className="mb-5 font-default text-3xl font-bold tracking-[-0.03em] text-slate-950 sm:text-4xl md:text-5xl">
          Жизнь <span className="text-[#166534]">центра</span>
        </h2>

        <div className="space-y-4 font-default text-lg leading-relaxed text-slate-700 md:text-xl">
          <p>
            Посмотрите, как проходят занятия, тренировки и активные мероприятия.
          </p>
          <p>
            Мы создаём пространство, где движение становится частью радостной и
            насыщенной жизни ребёнка.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-7xl">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:auto-rows-[220px] md:grid-cols-4 lg:auto-rows-[260px]">
          {galleryImages.map(image => <figure key={`${image.alt}-${image.caption}`} className={`group overflow-hidden rounded-[32px] border border-white/60 bg-white shadow-[0_14px_40px_rgba(15,23,42,0.06)] ${image.className}`}>
              <div className="relative h-full w-full overflow-hidden">
                <img src={image.src} alt={image.alt} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />
                <div className="absolute inset-x-0 bottom-0 bg-[linear-gradient(to_top,rgba(15,23,42,0.58),transparent)] p-5">
                  <figcaption className="font-default text-sm font-medium tracking-[0.02em] text-white/92 md:text-base">
                    {image.caption}
                  </figcaption>
                </div>
              </div>
            </figure>)}
        </div>
      </div>
    </section>;
}